import { reactive } from 'vue'
import type { IConsentForm } from '@/domains/direct-sales/types/ConsentForm.types'

export const CONSENT_KEYS: { key: keyof IConsentForm; text: string }[] = [
  { key: 'rodo', text: 'consent.rodo' },
  { key: 'email', text: 'consent.email' },
  { key: 'phone', text: 'consent.phone' },
  { key: 'partners', text: 'consent.partners' },
]

const createInitialConsent = (): IConsentForm => ({
  rodo: { value: false },
  email: { value: false },
  phone: { value: false },
  partners: { value: false },
})

export function useConsent() {
  const consentForm = reactive<IConsentForm>(createInitialConsent())

  const setAllConsents = (status: boolean) => {
    CONSENT_KEYS.forEach(({ key }) => {
      consentForm[key].value = status
    })
  }

  const resetConsent = () => {
    Object.assign(consentForm, createInitialConsent())
  }

  return {
    consentForm,
    consents: CONSENT_KEYS,
    setAllConsents,
    resetConsent,
  }
}
